export const idsToElements = (ids) => [...ids].reduce((obj, id) => {
  try {
    // Memoize elements
    MK.DOM.elements.byID[id] = MK.DOM.elements.byID[id] || document.getElementById(id)
    obj[id] = MK.DOM.elements.byID[id]
    if (!obj[id]) throw Error(`!!! ERROR (DOM.fns.idsToElements): Unable to locate element using ID: ${id}`)

    return obj
  } catch (error) {
    console.log(error)
    MK.captureException && MK.captureException(error)
    return {}
  }
}, {})
